import { H3, H5 } from '@components/Typography';
import styled from 'styled-components';

export const SectionRoot = styled.div`
  font-family: proxima-nova, sans-serif;
  padding: 10rem 6rem;

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width1280}) {
    padding: 6rem 2rem;
  }
`;

export const TitleWrapper = styled.div`
  margin: 2rem 0rem;

  text-align: center;
  width: 100%;

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width1280}) {
    margin: 1rem 0rem;
  }

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width768}) {
    margin: 1rem 0rem;
    text-align: left;
  }
`;

export const Title = styled(H3)<{ $color?: string }>`
  color: ${({ theme, $color }) => $color ?? theme.color.mobilityGrey};
  font-family: proxima-nova, sans-serif;
  font-size: ${({ theme }) => theme.fontSize.size40};
  font-weight: ${({ theme }) => theme.fontWeight.weight900};

  text-align: center;

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width768}) {
    font-size: ${({ theme }) => theme.fontSize.size35};
    line-height: ${({ theme }) => theme.lineHeight.height115};
    text-align: left;
  }

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width480}) {
    font-size: ${({ theme }) => theme.fontSize.size32};
    text-align: left;
  }
`;

export const SubtitleWrapper = styled.div`
  display: inline;
  max-width: 840px;
  text-align: center;

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width768}) {
    display: block;
    max-width: 100%;
    text-align: left;
  }
`;

export const Subtitle = styled(H5)<{ $color?: string }>`
  display: inline; // allows them to continue in the same line
  white-space: normal; // allows line breaks inside each paragraph
  margin-right: 1rem; // optional spacing between paragraphs
  color: ${({ theme, $color }) => $color ?? theme.color.mobilityGrey};
  font-family: proxima-nova, sans-serif;
  font-size: ${({ theme }) => theme.fontSize.size18};
  line-height: ${({ theme }) => theme.lineHeight.height165};

  margin-bottom: 4rem;

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width768}) {
    display: block;
    margin-bottom: 2rem;
  }

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width480}) {
    font-size: ${({ theme }) => theme.fontSize.size16};
    font-weight: ${({ theme }) => theme.fontWeight.weight500};
    line-height: ${({ theme }) => theme.lineHeight.height140};
  }
`;
